import React from 'react';
import PropTypes from 'prop-types';

var DndContext = require('./DndContext');

/**
 * Base DnD container
 * @prop {function}dndOnItemIn on item in container callback
 * @prop {function}dndOnItemOut on item out of container callback
 * @prop {function}dndOnItemOver on item out of container callback
 * @prop {function}dndOnItemDrop on item dropped in container callback
 * @prop {Array}dndDropTypes array of dropable types
 * @prop {string}className container css class
 */
const DndContainer = React.createClass({

  registerId: null,

  propTypes: {
    dndOnItemIn: PropTypes.func,
    dndOnItemOut: PropTypes.func,
    dndOnItemOver: PropTypes.func,
    dndOnItemDrop: PropTypes.func.isRequired,
    dndDropTypes: PropTypes.array.isRequired
  },

  contextTypes: {
    registerDndContainer: PropTypes.func,
    unregisterDndContainer: PropTypes.func
  },

  componentDidMount(){
    var self = this;
    this.registerId = this.context.registerDndContainer({
      element: self.refs.dndContainer,
      types: self.props.dndDropTypes,
      onMouseIn: self._onMouseIn,
      onMouseOut: self._onMouseOut,
      onMouseOver: self._onMouseOver,
      onDrop: self._onDrop,
      type: !!self._onMouseOver ? DndContext.TYPE_LIST : DndContext.TYPE_CONTAINER
    });
  },

  componentWillUnmount(){
    this.context.unregisterDndContainer(this.registerId);
  },

  render(){
    var {className} = this.props;
    return <div ref="dndContainer" className={className}>
      {this.props.children}
    </div>
  },

  _onMouseIn(itemType, data){
    if (typeof this.props.dndOnItemIn === "function") {
      this.props.dndOnItemIn(itemType, data);
    }
  },

  _onMouseOut(itemType){
    if (typeof this.props.dndOnItemOut === "function") {
      this.props.dndOnItemOut(itemType);
    }
  },

  _onMouseOver(itemType, event, draggableItemData, coordsData){
    if (typeof this.props.dndOnItemOver === "function") {
      this.props.dndOnItemOver(itemType, event, draggableItemData, coordsData);
    }
  },

  _onDrop(itemType, data){
    if (typeof this.props.dndOnItemDrop === "function") {
      this.props.dndOnItemDrop(itemType, data);
    }
  }

});

module.exports = DndContainer;
